import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import detector from "i18next-browser-languagedetector";

i18n
  .use(Backend)
  .use(detector)
  .use(initReactI18next)
  .init({
    supportedLngs: ["en", "de", "gu", "hi"],
    backend: {
      loadPath: "/locales/{{lng}}.json",
    },
    fallbackLng: ["en", "de", "gu", "hi"],
  });

export default i18n;

interface LanguageMap {
  [key: string]: string;
}

const languageCodeMap: LanguageMap = {
  'en': 'English',
  'de': 'German',
  'gu': 'Gujarati',
  'hi': 'Hindi'
};

export const getLanguageFullName = (code: string): string => {
  return languageCodeMap[code] || code;
};